/**
 * En-tête : retour + fil d'Ariane, recherche (Ctrl K), sélecteur de filiale (filiales autorisées, globe = toutes).
 * Liste des filiales = menu déroulant Radix (AppHeader.entityMenu) : choix exclusif, clavier, Échap, clic à côté.
 */
import { FILIALES, TOUTES_FILIALES, cleLibre, filiale as trouverFiliale } from '@agora/shared';
import { AppHeader, ShapeFlag, StatusBadge, WorldGlobe, type BreadcrumbProps } from '../../design';
import { useT, type Traduire } from '../i18n';
import { useSocle } from '../contexte';
import { useActionsEspace, useEtatEspace } from '../pages/espace';

export function nomFiliale(code: string, t: Traduire): string {
  if (code === TOUTES_FILIALES) return t('entete.toutesFiliales');
  const f = trouverFiliale(code);
  return f ? `${t(cleLibre('pays', f.pays))} — ${f.ville}` : code;
}

export function Entete({ fil, onRecherche }: { fil: BreadcrumbProps['items']; onRecherche: () => void }) {
  const { t } = useT();
  const { filiale, filialesAutorisees, changerFiliale, catalogue } = useSocle();
  const { aller } = useActionsEspace();
  const { pageActive } = useEtatEspace();

  const choix = [
    ...(filialesAutorisees.length > 1 ? [TOUTES_FILIALES] : []),
    ...FILIALES.filter((f) => filialesAutorisees.includes(f.code)).map((f) => f.code),
  ];

  return (
    <div className="agx-entete">
      <AppHeader
        breadcrumb={{ backLabel: t('nav.retour'), ariaLabel: t('nav.filAriane'), items: fil, onBack: () => aller(pageActive.id, -1) }}
        searchLabel={t('nav.rechercher')}
        searchHint={t('nav.raccourciRecherche')}
        onSearch={onRecherche}
        entity={{ code: filiale, name: nomFiliale(filiale, t), ariaPrefix: t('entete.filiale') }}
        entityMenu={{
          title: t('entete.choisirFiliale'), ariaLabel: t('entete.choisirFiliale'), className: 'agx-filiales', activeId: filiale,
          items: choix.map((code) => {
            const f = trouverFiliale(code);
            return {
              id: code, label: nomFiliale(code, t),
              leading: f ? <ShapeFlag country={f.pays} size={20} /> : <WorldGlobe size={20} />,
              trailing: f ? <span className="ag-mono agx-code">{code}</span> : undefined,
            };
          }),
          onSelect: changerFiliale,
        }}
        entityNote={catalogue?.consolidee ? <span className="agx-note-entete"><StatusBadge status="neutral" label={t('entete.vueConsolidee')} /></span> : null}
      />
    </div>
  );
}
